const countryCodes = [
    {
        "code": "+1",
        "name": "United States",
        "iso": "us",
        "placeholder": "201 555 0123",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+44",
        "name": "United Kingdom",
        "iso": "gb",
        "placeholder": "7123 456789",
        "regex": "^\\d{4} \\d{6}$"
    },
    {
        "code": "+93",
        "name": "Afghanistan",
        "iso": "af",
        "placeholder": "070 123 4567",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+355",
        "name": "Albania",
        "iso": "al",
        "placeholder": "066 123 4567",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+213",
        "name": "Algeria",
        "iso": "dz",
        "placeholder": "0551 23 45 67",
        "regex": "^\\d{4} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+1",
        "name": "American Samoa",
        "iso": "as",
        "placeholder": "684 733 1234",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+376",
        "name": "Andorra",
        "iso": "ad",
        "placeholder": "312 345",
        "regex": "^\\d{3} \\d{3}$"
    },
    {
        "code": "+244",
        "name": "Angola",
        "iso": "ao",
        "placeholder": "923 123 456",
        "regex": "^\\d{3} \\d{3} \\d{3}$"
    },
    {
        "code": "+1",
        "name": "Anguilla",
        "iso": "ai",
        "placeholder": "264 235 1234",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+1",
        "name": "Antigua & Barbuda",
        "iso": "ag",
        "placeholder": "268 464 1234",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+54",
        "name": "Argentina",
        "iso": "ar",
        "placeholder": "11 2345 6789",
        "regex": "^\\d{2} \\d{4} \\d{4}$"
    },
    {
        "code": "+374",
        "name": "Armenia",
        "iso": "am",
        "placeholder": "077 123456",
        "regex": "^\\d{3} \\d{6}$"
    },
    {
        "code": "+297",
        "name": "Aruba",
        "iso": "aw",
        "placeholder": "560 1234",
        "regex": "^\\d{3} \\d{4}$"
    },
    {
        "code": "+247",
        "name": "Ascension Island",
        "iso": "ac",
        "placeholder": "5000",
        "regex": "^\\d{4}$"
    },
    {
        "code": "+61",
        "name": "Australia",
        "iso": "au",
        "placeholder": "0412 345 678",
        "regex": "^\\d{4} \\d{3} \\d{3}$"
    },
    {
        "code": "+43",
        "name": "Austria",
        "iso": "at",
        "placeholder": "0664 1234567",
        "regex": "^\\d{4} \\d{7}$"
    },
    {
        "code": "+994",
        "name": "Azerbaijan",
        "iso": "az",
        "placeholder": "040 123 45 67",
        "regex": "^\\d{3} \\d{3} \\d{2} \\d{2}$"
    },
    {
        "code": "+1",
        "name": "Bahamas",
        "iso": "bs",
        "placeholder": "242 359 1234",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+973",
        "name": "Bahrain",
        "iso": "bh",
        "placeholder": "3600 1234",
        "regex": "^\\d{4} \\d{4}$"
    },
    {
        "code": "+880",
        "name": "Bangladesh",
        "iso": "bd",
        "placeholder": "01812 345678",
        "regex": "^\\d{5} \\d{6}$"
    },
    {
        "code": "+1",
        "name": "Barbados",
        "iso": "bb",
        "placeholder": "246 250 1234",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+375",
        "name": "Belarus",
        "iso": "by",
        "placeholder": "8 029 123 45 67",
        "regex": "^\\d \\d{3} \\d{3} \\d{2} \\d{2}$"
    },
    {
        "code": "+32",
        "name": "Belgium",
        "iso": "be",
        "placeholder": "0XXX XX XX XX",
        "regex": "^0\\d{3} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+501",
        "name": "Belize",
        "iso": "bz",
        "placeholder": "622 1234",
        "regex": "^\\d{3} \\d{4}$"
    },
    {
        "code": "+229",
        "name": "Benin",
        "iso": "bj",
        "placeholder": "90 01 23 45",
        "regex": "^\\d{2} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+1",
        "name": "Bermuda",
        "iso": "bm",
        "placeholder": "441 370 1234",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+975",
        "name": "Bhutan",
        "iso": "bt",
        "placeholder": "17 12 34 56",
        "regex": "^\\d{2} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+591",
        "name": "Bolivia",
        "iso": "bo",
        "placeholder": "71234567",
        "regex": "^\\d{8}$"
    },
    {
        "code": "+387",
        "name": "Bosnia & Herzegovina",
        "iso": "ba",
        "placeholder": "061 123 456",
        "regex": "^\\d{3} \\d{3} \\d{3}$"
    },
    {
        "code": "+267",
        "name": "Botswana",
        "iso": "bw",
        "placeholder": "71 123 456",
        "regex": "^\\d{2} \\d{3} \\d{3}$"
    },
    {
        "code": "+55",
        "name": "Brazil",
        "iso": "br",
        "placeholder": "11 91234 5678",
        "regex": "^\\d{2} \\d{5} \\d{4}$"
    },
    {
        "code": "+246",
        "name": "British Indian Ocean Territory",
        "iso": "io",
        "placeholder": "380 1234",
        "regex": "^\\d{3} \\d{4}$"
    },
    {
        "code": "+1",
        "name": "British Virgin Islands",
        "iso": "vg",
        "placeholder": "284 300 1234",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+673",
        "name": "Brunei",
        "iso": "bn",
        "placeholder": "712 3456",
        "regex": "^\\d{3} \\d{4}$"
    },
    {
        "code": "+359",
        "name": "Bulgaria",
        "iso": "bg",
        "placeholder": "087 123 4567",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+226",
        "name": "Burkina Faso",
        "iso": "bf",
        "placeholder": "70 12 34 56",
        "regex": "^\\d{2} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+257",
        "name": "Burundi",
        "iso": "bi",
        "placeholder": "79 123 456",
        "regex": "^\\d{2} \\d{3} \\d{3}$"
    },
    {
        "code": "+855",
        "name": "Cambodia",
        "iso": "kh",
        "placeholder": "012 345 678",
        "regex": "^\\d{3} \\d{3} \\d{3}$"
    },
    {
        "code": "+237",
        "name": "Cameroon",
        "iso": "cm",
        "placeholder": "6 71 23 45 67",
        "regex": "^\\d \\d{2} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+1",
        "name": "Canada",
        "iso": "ca",
        "placeholder": "204 123 4567",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+238",
        "name": "Cape Verde",
        "iso": "cv",
        "placeholder": "991 12 34",
        "regex": "^\\d{3} \\d{2} \\d{2}$"
    },
    {
        "code": "+599",
        "name": "Caribbean Netherlands",
        "iso": "bq",
        "placeholder": "318 1234",
        "regex": "^\\d{3} \\d{4}$"
    },
    {
        "code": "+1",
        "name": "Cayman Islands",
        "iso": "ky",
        "placeholder": "345 323 1234",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+236",
        "name": "Central African Republic",
        "iso": "cf",
        "placeholder": "70 01 23 45",
        "regex": "^\\d{2} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+235",
        "name": "Chad",
        "iso": "td",
        "placeholder": "63 01 23 45",
        "regex": "^\\d{2} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+56",
        "name": "Chile",
        "iso": "cl",
        "placeholder": "9 6123 4567",
        "regex": "^\\d \\d{4} \\d{4}$"
    },
    {
        "code": "+86",
        "name": "China",
        "iso": "cn",
        "placeholder": "131 2345 6789",
        "regex": "^\\d{3} \\d{4} \\d{4}$"
    },
    {
        "code": "+61",
        "name": "Christmas Island",
        "iso": "cx",
        "placeholder": "0412 345 678",
        "regex": "^\\d{4} \\d{3} \\d{3}$"
    },
    {
        "code": "+61",
        "name": "Cocos (Keeling) Islands",
        "iso": "cc",
        "placeholder": "0412 345 678",
        "regex": "^\\d{4} \\d{3} \\d{3}$"
    },
    {
        "code": "+57",
        "name": "Colombia",
        "iso": "co",
        "placeholder": "310 123 4567",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+269",
        "name": "Comoros",
        "iso": "km",
        "placeholder": "321 23 45",
        "regex": "^\\d{3} \\d{2} \\d{2}$"
    },
    {
        "code": "+242",
        "name": "Congo - Brazzaville",
        "iso": "cg",
        "placeholder": "06 123 4567",
        "regex": "^\\d{2} \\d{3} \\d{4}$"
    },
    {
        "code": "+243",
        "name": "Congo - Kinshasa",
        "iso": "cd",
        "placeholder": "081 123 4567",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+682",
        "name": "Cook Islands",
        "iso": "ck",
        "placeholder": "71 234",
        "regex": "^\\d{2} \\d{3}$"
    },
    {
        "code": "+506",
        "name": "Costa Rica",
        "iso": "cr",
        "placeholder": "8312 3456",
        "regex": "^\\d{4} \\d{4}$"
    },
    {
        "code": "+225",
        "name": "Côte d’Ivoire",
        "iso": "ci",
        "placeholder": "01 23 45 67",
        "regex": "^\\d{2} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+385",
        "name": "Croatia",
        "iso": "hr",
        "placeholder": "091 234 5678",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+53",
        "name": "Cuba",
        "iso": "cu",
        "placeholder": "05 1234567",
        "regex": "^\\d{2} \\d{7}$"
    },
    {
        "code": "+599",
        "name": "Curaçao",
        "iso": "cw",
        "placeholder": "9 518 1234",
        "regex": "^\\d \\d{3} \\d{4}$"
    },
    {
        "code": "+357",
        "name": "Cyprus",
        "iso": "cy",
        "placeholder": "96 123456",
        "regex": "^\\d{2} \\d{6}$"
    },
    {
        "code": "+420",
        "name": "Czech Republic",
        "iso": "cz",
        "placeholder": "601 123 456",
        "regex": "^\\d{3} \\d{3} \\d{3}$"
    },
    {
        "code": "+45",
        "name": "Denmark",
        "iso": "dk",
        "placeholder": "20 12 34 56",
        "regex": "^\\d{2} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+253",
        "name": "Djibouti",
        "iso": "dj",
        "placeholder": "77 83 10 01",
        "regex": "^\\d{2} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+1",
        "name": "Dominica",
        "iso": "dm",
        "placeholder": "767 225 1234",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+1",
        "name": "Dominican Republic",
        "iso": "do",
        "placeholder": "809 234 5678",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+593",
        "name": "Ecuador",
        "iso": "ec",
        "placeholder": "099 123 4567",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+20",
        "name": "Egypt",
        "iso": "eg",
        "placeholder": "0100 123 4567",
        "regex": "^\\d{4} \\d{3} \\d{4}$"
    },
    {
        "code": "+503",
        "name": "El Salvador",
        "iso": "sv",
        "placeholder": "7012 3456",
        "regex": "^\\d{4} \\d{4}$"
    },
    {
        "code": "+240",
        "name": "Equatorial Guinea",
        "iso": "gq",
        "placeholder": "222 123 456",
        "regex": "^\\d{3} \\d{3} \\d{3}$"
    },
    {
        "code": "+291",
        "name": "Eritrea",
        "iso": "er",
        "placeholder": "07 123 456",
        "regex": "^\\d{2} \\d{3} \\d{3}$"
    },
    {
        "code": "+372",
        "name": "Estonia",
        "iso": "ee",
        "placeholder": "5123 4567",
        "regex": "^\\d{4} \\d{4}$"
    },
    {
        "code": "+268",
        "name": "Eswatini",
        "iso": "sz",
        "placeholder": "7612 3456",
        "regex": "^\\d{4} \\d{4}$"
    },
    {
        "code": "+251",
        "name": "Ethiopia",
        "iso": "et",
        "placeholder": "091 123 4567",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+500",
        "name": "Falkland Islands",
        "iso": "fk",
        "placeholder": "51234",
        "regex": "^\\d{5}$"
    },
    {
        "code": "+298",
        "name": "Faroe Islands",
        "iso": "fo",
        "placeholder": "211234",
        "regex": "^\\d{6}$"
    },
    {
        "code": "+679",
        "name": "Fiji",
        "iso": "fj",
        "placeholder": "701 2345",
        "regex": "^\\d{3} \\d{4}$"
    },
    {
        "code": "+358",
        "name": "Finland",
        "iso": "fi",
        "placeholder": "041 2345678",
        "regex": "^\\d{3} \\d{7}$"
    },
    {
        "code": "+33",
        "name": "France",
        "iso": "fr",
        "placeholder": "0X XX XX XX XX",
        "regex": "^0\\d \\d{2} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+594",
        "name": "French Guiana",
        "iso": "gf",
        "placeholder": "0694 20 12 34",
        "regex": "^\\d{4} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+689",
        "name": "French Polynesia",
        "iso": "pf",
        "placeholder": "87 12 34 56",
        "regex": "^\\d{2} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+241",
        "name": "Gabon",
        "iso": "ga",
        "placeholder": "06 03 12 34",
        "regex": "^\\d{2} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+220",
        "name": "Gambia",
        "iso": "gm",
        "placeholder": "301 2345",
        "regex": "^\\d{3} \\d{4}$"
    },
    {
        "code": "+995",
        "name": "Georgia",
        "iso": "ge",
        "placeholder": "555 12 34 56",
        "regex": "^\\d{3} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+49",
        "name": "Germany",
        "iso": "de",
        "placeholder": "01512 3456789",
        "regex": "^\\d{5} \\d{7}$"
    },
    {
        "code": "+233",
        "name": "Ghana",
        "iso": "gh",
        "placeholder": "023 456 7890",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+350",
        "name": "Gibraltar",
        "iso": "gi",
        "placeholder": "57123456",
        "regex": "^\\d{8}$"
    },
    {
        "code": "+30",
        "name": "Greece",
        "iso": "gr",
        "placeholder": "691 234 5678",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+299",
        "name": "Greenland",
        "iso": "gl",
        "placeholder": "22 12 34",
        "regex": "^\\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+1",
        "name": "Grenada",
        "iso": "gd",
        "placeholder": "473 403 1234",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+590",
        "name": "Guadeloupe",
        "iso": "gp",
        "placeholder": "0690 30 12 34",
        "regex": "^\\d{4} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+1",
        "name": "Guam",
        "iso": "gu",
        "placeholder": "671 300 1234",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+502",
        "name": "Guatemala",
        "iso": "gt",
        "placeholder": "5123 4567",
        "regex": "^\\d{4} \\d{4}$"
    },
    {
        "code": "+44",
        "name": "Guernsey",
        "iso": "gg",
        "placeholder": "07781 123456",
        "regex": "^\\d{5} \\d{6}$"
    },
    {
        "code": "+224",
        "name": "Guinea",
        "iso": "gn",
        "placeholder": "601 12 34 56",
        "regex": "^\\d{3} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+245",
        "name": "Guinea-Bissau",
        "iso": "gw",
        "placeholder": "955 012 345",
        "regex": "^\\d{3} \\d{3} \\d{3}$"
    },
    {
        "code": "+592",
        "name": "Guyana",
        "iso": "gy",
        "placeholder": "609 1234",
        "regex": "^\\d{3} \\d{4}$"
    },
    {
        "code": "+509",
        "name": "Haiti",
        "iso": "ht",
        "placeholder": "34 10 1234",
        "regex": "^\\d{2} \\d{2} \\d{4}$"
    },
    {
        "code": "+504",
        "name": "Honduras",
        "iso": "hn",
        "placeholder": "9123 4567",
        "regex": "^\\d{4} \\d{4}$"
    },
    {
        "code": "+852",
        "name": "Hong Kong",
        "iso": "hk",
        "placeholder": "5123 4567",
        "regex": "^\\d{4} \\d{4}$"
    },
    {
        "code": "+36",
        "name": "Hungary",
        "iso": "hu",
        "placeholder": "20 123 4567",
        "regex": "^\\d{2} \\d{3} \\d{4}$"
    },
    {
        "code": "+354",
        "name": "Iceland",
        "iso": "is",
        "placeholder": "610 1234",
        "regex": "^\\d{3} \\d{4}$"
    },
    {
        "code": "+91",
        "name": "India",
        "iso": "in",
        "placeholder": "098765 43210",
        "regex": "^\\d{5} \\d{5}$"
    },
    {
        "code": "+62",
        "name": "Indonesia",
        "iso": "id",
        "placeholder": "0812 345 678",
        "regex": "^\\d{4} \\d{3} \\d{3}$"
    },
    {
        "code": "+98",
        "name": "Iran",
        "iso": "ir",
        "placeholder": "0912 345 6789",
        "regex": "^\\d{4} \\d{3} \\d{4}$"
    },
    {
        "code": "+964",
        "name": "Iraq",
        "iso": "iq",
        "placeholder": "0790 123 4567",
        "regex": "^\\d{4} \\d{3} \\d{4}$"
    },
    {
        "code": "+353",
        "name": "Ireland",
        "iso": "ie",
        "placeholder": "085 012 3456",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+44",
        "name": "Isle of Man",
        "iso": "im",
        "placeholder": "07924 123456",
        "regex": "^\\d{5} \\d{6}$"
    },
    {
        "code": "+972",
        "name": "Israel",
        "iso": "il",
        "placeholder": "050 123 4567",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+39",
        "name": "Italy",
        "iso": "it",
        "placeholder": "312 345 6789",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+1",
        "name": "Jamaica",
        "iso": "jm",
        "placeholder": "876 210 1234",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+81",
        "name": "Japan",
        "iso": "jp",
        "placeholder": "090 1234 5678",
        "regex": "^\\d{3} \\d{4} \\d{4}$"
    },
    {
        "code": "+44",
        "name": "Jersey",
        "iso": "je",
        "placeholder": "07797 123456",
        "regex": "^\\d{5} \\d{6}$"
    },
    {
        "code": "+962",
        "name": "Jordan",
        "iso": "jo",
        "placeholder": "07 9012 3456",
        "regex": "^\\d{2} \\d{4} \\d{4}$"
    },
    {
        "code": "+7",
        "name": "Kazakhstan",
        "iso": "kz",
        "placeholder": "8 771 000 9998",
        "regex": "^\\d \\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+254",
        "name": "Kenya",
        "iso": "ke",
        "placeholder": "0712 345678",
        "regex": "^\\d{4} \\d{6}$"
    },
    {
        "code": "+686",
        "name": "Kiribati",
        "iso": "ki",
        "placeholder": "72012345",
        "regex": "^\\d{8}$"
    },
    {
        "code": "+383",
        "name": "Kosovo",
        "iso": "xk",
        "placeholder": "043 201 234",
        "regex": "^\\d{3} \\d{3} \\d{3}$"
    },
    {
        "code": "+965",
        "name": "Kuwait",
        "iso": "kw",
        "placeholder": "500 12345",
        "regex": "^\\d{3} \\d{5}$"
    },
    {
        "code": "+996",
        "name": "Kyrgyzstan",
        "iso": "kg",
        "placeholder": "0700 123 456",
        "regex": "^\\d{4} \\d{3} \\d{3}$"
    },
    {
        "code": "+856",
        "name": "Laos",
        "iso": "la",
        "placeholder": "020 23 123 456",
        "regex": "^\\d{3} \\d{2} \\d{3} \\d{3}$"
    },
    {
        "code": "+371",
        "name": "Latvia",
        "iso": "lv",
        "placeholder": "21 234 567",
        "regex": "^\\d{2} \\d{3} \\d{3}$"
    },
    {
        "code": "+961",
        "name": "Lebanon",
        "iso": "lb",
        "placeholder": "03 123 456",
        "regex": "^\\d{2} \\d{3} \\d{3}$"
    },
    {
        "code": "+266",
        "name": "Lesotho",
        "iso": "ls",
        "placeholder": "5012 3456",
        "regex": "^\\d{4} \\d{4}$"
    },
    {
        "code": "+231",
        "name": "Liberia",
        "iso": "lr",
        "placeholder": "077 012 3456",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+218",
        "name": "Libya",
        "iso": "ly",
        "placeholder": "091 2345678",
        "regex": "^\\d{3} \\d{7}$"
    },
    {
        "code": "+423",
        "name": "Liechtenstein",
        "iso": "li",
        "placeholder": "660 123 456",
        "regex": "^\\d{3} \\d{3} \\d{3}$"
    },
    {
        "code": "+370",
        "name": "Lithuania",
        "iso": "lt",
        "placeholder": "612 34567",
        "regex": "^\\d{3} \\d{5}$"
    },
    {
        "code": "+352",
        "name": "Luxembourg",
        "iso": "lu",
        "placeholder": "621 123 456",
        "regex": "^\\d{3} \\d{3} \\d{3}$"
    },
    {
        "code": "+853",
        "name": "Macau",
        "iso": "mo",
        "placeholder": "6612 3456",
        "regex": "^\\d{4} \\d{4}$"
    },
    {
        "code": "+261",
        "name": "Madagascar",
        "iso": "mg",
        "placeholder": "032 12 345 67",
        "regex": "^\\d{3} \\d{2} \\d{3} \\d{2}$"
    },
    {
        "code": "+265",
        "name": "Malawi",
        "iso": "mw",
        "placeholder": "0991 23 45 67",
        "regex": "^\\d{4} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+60",
        "name": "Malaysia",
        "iso": "my",
        "placeholder": "012 345 6789",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+960",
        "name": "Maldives",
        "iso": "mv",
        "placeholder": "772 1234",
        "regex": "^\\d{3} \\d{4}$"
    },
    {
        "code": "+223",
        "name": "Mali",
        "iso": "ml",
        "placeholder": "65 01 23 45",
        "regex": "^\\d{2} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+356",
        "name": "Malta",
        "iso": "mt",
        "placeholder": "9923 4567",
        "regex": "^\\d{4} \\d{4}$"
    },
    {
        "code": "+692",
        "name": "Marshall Islands",
        "iso": "mh",
        "placeholder": "235 1234",
        "regex": "^\\d{3} \\d{4}$"
    },
    {
        "code": "+596",
        "name": "Martinique",
        "iso": "mq",
        "placeholder": "0696 20 12 34",
        "regex": "^\\d{4} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+222",
        "name": "Mauritania",
        "iso": "mr",
        "placeholder": "22 12 34 56",
        "regex": "^\\d{2} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+230",
        "name": "Mauritius",
        "iso": "mu",
        "placeholder": "5251 2345",
        "regex": "^\\d{4} \\d{4}$"
    },
    {
        "code": "+262",
        "name": "Mayotte",
        "iso": "yt",
        "placeholder": "0639 01 23 45",
        "regex": "^\\d{4} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+52",
        "name": "Mexico",
        "iso": "mx",
        "placeholder": "55 1234 5678",
        "regex": "^\\d{2} \\d{4} \\d{4}$"
    },
    {
        "code": "+691",
        "name": "Micronesia",
        "iso": "fm",
        "placeholder": "350 1234",
        "regex": "^\\d{3} \\d{4}$"
    },
    {
        "code": "+373",
        "name": "Moldova",
        "iso": "md",
        "placeholder": "0621 12 345",
        "regex": "^\\d{4} \\d{2} \\d{3}$"
    },
    {
        "code": "+377",
        "name": "Monaco",
        "iso": "mc",
        "placeholder": "06 12 34 56 78",
        "regex": "^\\d{2} \\d{2} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+976",
        "name": "Mongolia",
        "iso": "mn",
        "placeholder": "8812 3456",
        "regex": "^\\d{4} \\d{4}$"
    },
    {
        "code": "+382",
        "name": "Montenegro",
        "iso": "me",
        "placeholder": "067 622 901",
        "regex": "^\\d{3} \\d{3} \\d{3}$"
    },
    {
        "code": "+1",
        "name": "Montserrat",
        "iso": "ms",
        "placeholder": "664 492 1234",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+212",
        "name": "Morocco",
        "iso": "ma",
        "placeholder": "0650 123456",
        "regex": "^\\d{4} \\d{6}$"
    },
    {
        "code": "+258",
        "name": "Mozambique",
        "iso": "mz",
        "placeholder": "82 123 4567",
        "regex": "^\\d{2} \\d{3} \\d{4}$"
    },
    {
        "code": "+95",
        "name": "Myanmar (Burma)",
        "iso": "mm",
        "placeholder": "09 123 456 789",
        "regex": "^\\d{2} \\d{3} \\d{3} \\d{3}$"
    },
    {
        "code": "+264",
        "name": "Namibia",
        "iso": "na",
        "placeholder": "081 123 4567",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+674",
        "name": "Nauru",
        "iso": "nr",
        "placeholder": "555 1234",
        "regex": "^\\d{3} \\d{4}$"
    },
    {
        "code": "+977",
        "name": "Nepal",
        "iso": "np",
        "placeholder": "984 1234567",
        "regex": "^\\d{3} \\d{7}$"
    },
    {
        "code": "+31",
        "name": "Netherlands",
        "iso": "nl",
        "placeholder": "06 XX XX XX XX",
        "regex": "^06 \\d{2} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+687",
        "name": "New Caledonia",
        "iso": "nc",
        "placeholder": "75 12 34",
        "regex": "^\\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+64",
        "name": "New Zealand",
        "iso": "nz",
        "placeholder": "021 123 4567",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+505",
        "name": "Nicaragua",
        "iso": "ni",
        "placeholder": "8123 4567",
        "regex": "^\\d{4} \\d{4}$"
    },
    {
        "code": "+227",
        "name": "Niger",
        "iso": "ne",
        "placeholder": "93 12 34 56",
        "regex": "^\\d{2} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+234",
        "name": "Nigeria",
        "iso": "ng",
        "placeholder": "0802 123 4567",
        "regex": "^\\d{4} \\d{3} \\d{4}$"
    },
    {
        "code": "+683",
        "name": "Niue",
        "iso": "nu",
        "placeholder": "888 4012",
        "regex": "^\\d{3} \\d{4}$"
    },
    {
        "code": "+672",
        "name": "Norfolk Island",
        "iso": "nf",
        "placeholder": "3 81234",
        "regex": "^\\d \\d{5}$"
    },
    {
        "code": "+850",
        "name": "North Korea",
        "iso": "kp",
        "placeholder": "0192 123 4567",
        "regex": "^\\d{4} \\d{3} \\d{4}$"
    },
    {
        "code": "+389",
        "name": "North Macedonia",
        "iso": "mk",
        "placeholder": "070 123 456",
        "regex": "^\\d{3} \\d{3} \\d{3}$"
    },
    {
        "code": "+1",
        "name": "Northern Mariana Islands",
        "iso": "mp",
        "placeholder": "670 234 5678",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+47",
        "name": "Norway",
        "iso": "no",
        "placeholder": "406 12 345",
        "regex": "^\\d{3} \\d{2} \\d{3}$"
    },
    {
        "code": "+968",
        "name": "Oman",
        "iso": "om",
        "placeholder": "9212 3456",
        "regex": "^\\d{4} \\d{4}$"
    },
    {
        "code": "+92",
        "name": "Pakistan",
        "iso": "pk",
        "placeholder": "0301 2345678",
        "regex": "^\\d{4} \\d{7}$"
    },
    {
        "code": "+680",
        "name": "Palau",
        "iso": "pw",
        "placeholder": "620 1234",
        "regex": "^\\d{3} \\d{4}$"
    },
    {
        "code": "+970",
        "name": "Palestine",
        "iso": "ps",
        "placeholder": "0599 123 456",
        "regex": "^\\d{4} \\d{3} \\d{3}$"
    },
    {
        "code": "+507",
        "name": "Panama",
        "iso": "pa",
        "placeholder": "6123 4567",
        "regex": "^\\d{4} \\d{4}$"
    },
    {
        "code": "+675",
        "name": "Papua New Guinea",
        "iso": "pg",
        "placeholder": "7012 3456",
        "regex": "^\\d{4} \\d{4}$"
    },
    {
        "code": "+595",
        "name": "Paraguay",
        "iso": "py",
        "placeholder": "0961 456789",
        "regex": "^\\d{4} \\d{6}$"
    },
    {
        "code": "+51",
        "name": "Peru",
        "iso": "pe",
        "placeholder": "912 345 678",
        "regex": "^\\d{3} \\d{3} \\d{3}$"
    },
    {
        "code": "+63",
        "name": "Philippines",
        "iso": "ph",
        "placeholder": "0912 345 6789",
        "regex": "^\\d{4} \\d{3} \\d{4}$"
    },
    {
        "code": "+48",
        "name": "Poland",
        "iso": "pl",
        "placeholder": "512 345 678",
        "regex": "^\\d{3} \\d{3} \\d{3}$"
    },
    {
        "code": "+351",
        "name": "Portugal",
        "iso": "pt",
        "placeholder": "912 345 678",
        "regex": "^\\d{3} \\d{3} \\d{3}$"
    },
    {
        "code": "+1",
        "name": "Puerto Rico",
        "iso": "pr",
        "placeholder": "787 234 5678",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+974",
        "name": "Qatar",
        "iso": "qa",
        "placeholder": "3312 3456",
        "regex": "^\\d{4} \\d{4}$"
    },
    {
        "code": "+262",
        "name": "Réunion",
        "iso": "re",
        "placeholder": "0692 12 34 56",
        "regex": "^\\d{4} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+40",
        "name": "Romania",
        "iso": "ro",
        "placeholder": "0712 345 678",
        "regex": "^\\d{4} \\d{3} \\d{3}$"
    },
    {
        "code": "+7",
        "name": "Russia",
        "iso": "ru",
        "placeholder": "8 912 123 45 67",
        "regex": "^\\d \\d{3} \\d{3} \\d{2} \\d{2}$"
    },
    {
        "code": "+250",
        "name": "Rwanda",
        "iso": "rw",
        "placeholder": "0788 123 456",
        "regex": "^\\d{4} \\d{3} \\d{3}$"
    },
    {
        "code": "+685",
        "name": "Samoa",
        "iso": "ws",
        "placeholder": "72 12345",
        "regex": "^\\d{2} \\d{5}$"
    },
    {
        "code": "+378",
        "name": "San Marino",
        "iso": "sm",
        "placeholder": "0549 88 1234",
        "regex": "^\\d{4} \\d{2} \\d{4}$"
    },
    {
        "code": "+239",
        "name": "São Tomé & Príncipe",
        "iso": "st",
        "placeholder": "981 1234",
        "regex": "^\\d{3} \\d{4}$"
    },
    {
        "code": "+966",
        "name": "Saudi Arabia",
        "iso": "sa",
        "placeholder": "051 234 5678",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+221",
        "name": "Senegal",
        "iso": "sn",
        "placeholder": "70 123 45 67",
        "regex": "^\\d{2} \\d{3} \\d{2} \\d{2}$"
    },
    {
        "code": "+381",
        "name": "Serbia",
        "iso": "rs",
        "placeholder": "060 123 4567",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+248",
        "name": "Seychelles",
        "iso": "sc",
        "placeholder": "2 510 123",
        "regex": "^\\d \\d{3} \\d{3}$"
    },
    {
        "code": "+232",
        "name": "Sierra Leone",
        "iso": "sl",
        "placeholder": "025 123456",
        "regex": "^\\d{3} \\d{6}$"
    },
    {
        "code": "+65",
        "name": "Singapore",
        "iso": "sg",
        "placeholder": "8123 4567",
        "regex": "^\\d{4} \\d{4}$"
    },
    {
        "code": "+1",
        "name": "Sint Maarten",
        "iso": "sx",
        "placeholder": "721 520 5678",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+421",
        "name": "Slovakia",
        "iso": "sk",
        "placeholder": "0912 123 456",
        "regex": "^\\d{4} \\d{3} \\d{3}$"
    },
    {
        "code": "+386",
        "name": "Slovenia",
        "iso": "si",
        "placeholder": "031 234 567",
        "regex": "^\\d{3} \\d{3} \\d{3}$"
    },
    {
        "code": "+677",
        "name": "Solomon Islands",
        "iso": "sb",
        "placeholder": "74 12345",
        "regex": "^\\d{2} \\d{5}$"
    },
    {
        "code": "+252",
        "name": "Somalia",
        "iso": "so",
        "placeholder": "7 1123456",
        "regex": "^\\d \\d{7}$"
    },
    {
        "code": "+27",
        "name": "South Africa",
        "iso": "za",
        "placeholder": "071 123 4567",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+82",
        "name": "South Korea",
        "iso": "kr",
        "placeholder": "010 1234 5678",
        "regex": "^\\d{3} \\d{4} \\d{4}$"
    },
    {
        "code": "+211",
        "name": "South Sudan",
        "iso": "ss",
        "placeholder": "0977 123 456",
        "regex": "^\\d{4} \\d{3} \\d{3}$"
    },
    {
        "code": "+34",
        "name": "Spain",
        "iso": "es",
        "placeholder": "612 34 56 78",
        "regex": "^\\d{3} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+94",
        "name": "Sri Lanka",
        "iso": "lk",
        "placeholder": "071 123 4567",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+590",
        "name": "St Barthélemy",
        "iso": "bl",
        "placeholder": "0690 00 12 34",
        "regex": "^\\d{4} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+290",
        "name": "St Helena",
        "iso": "sh",
        "placeholder": "51234",
        "regex": "^\\d{5}$"
    },
    {
        "code": "+1",
        "name": "St Kitts & Nevis",
        "iso": "kn",
        "placeholder": "869 765 2917",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+1",
        "name": "St Lucia",
        "iso": "lc",
        "placeholder": "758 284 5678",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+590",
        "name": "St Martin",
        "iso": "mf",
        "placeholder": "0690 00 12 34",
        "regex": "^\\d{4} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+508",
        "name": "St Pierre & Miquelon",
        "iso": "pm",
        "placeholder": "055 12 34",
        "regex": "^\\d{3} \\d{2} \\d{2}$"
    },
    {
        "code": "+1",
        "name": "St Vincent & Grenadines",
        "iso": "vc",
        "placeholder": "784 430 1234",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+249",
        "name": "Sudan",
        "iso": "sd",
        "placeholder": "091 123 1234",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+597",
        "name": "Suriname",
        "iso": "sr",
        "placeholder": "741 2345",
        "regex": "^\\d{3} \\d{4}$"
    },
    {
        "code": "+47",
        "name": "Svalbard & Jan Mayen",
        "iso": "sj",
        "placeholder": "79 02 345",
        "regex": "^\\d{2} \\d{2} \\d{3}$"
    },
    {
        "code": "+46",
        "name": "Sweden",
        "iso": "se",
        "placeholder": "070 123 45 67",
        "regex": "^\\d{3} \\d{3} \\d{2} \\d{2}$"
    },
    {
        "code": "+41",
        "name": "Switzerland",
        "iso": "ch",
        "placeholder": "078 123 45 67",
        "regex": "^\\d{3} \\d{3} \\d{2} \\d{2}$"
    },
    {
        "code": "+963",
        "name": "Syria",
        "iso": "sy",
        "placeholder": "0944 567 890",
        "regex": "^\\d{4} \\d{3} \\d{3}$"
    },
    {
        "code": "+886",
        "name": "Taiwan",
        "iso": "tw",
        "placeholder": "0912 345 678",
        "regex": "^\\d{4} \\d{3} \\d{3}$"
    },
    {
        "code": "+992",
        "name": "Tajikistan",
        "iso": "tj",
        "placeholder": "917 12 3456",
        "regex": "^\\d{3} \\d{2} \\d{4}$"
    },
    {
        "code": "+255",
        "name": "Tanzania",
        "iso": "tz",
        "placeholder": "0621 234 567",
        "regex": "^\\d{4} \\d{3} \\d{3}$"
    },
    {
        "code": "+66",
        "name": "Thailand",
        "iso": "th",
        "placeholder": "081 234 5678",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+670",
        "name": "Timor-Leste",
        "iso": "tl",
        "placeholder": "7721 2345",
        "regex": "^\\d{4} \\d{4}$"
    },
    {
        "code": "+228",
        "name": "Togo",
        "iso": "tg",
        "placeholder": "90 11 23 45",
        "regex": "^\\d{2} \\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+690",
        "name": "Tokelau",
        "iso": "tk",
        "placeholder": "7290",
        "regex": "^\\d{4}$"
    },
    {
        "code": "+676",
        "name": "Tonga",
        "iso": "to",
        "placeholder": "771 5123",
        "regex": "^\\d{3} \\d{4}$"
    },
    {
        "code": "+1",
        "name": "Trinidad & Tobago",
        "iso": "tt",
        "placeholder": "868 291 1234",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+216",
        "name": "Tunisia",
        "iso": "tn",
        "placeholder": "20 123 456",
        "regex": "^\\d{2} \\d{3} \\d{3}$"
    },
    {
        "code": "+90",
        "name": "Turkey",
        "iso": "tr",
        "placeholder": "0501 234 56 78",
        "regex": "^05\\d{2} \\d{3} \\d{2} \\d{2}$"
    },
    {
        "code": "+993",
        "name": "Turkmenistan",
        "iso": "tm",
        "placeholder": "8 63 123456",
        "regex": "^\\d \\d{2} \\d{6}$"
    },
    {
        "code": "+1",
        "name": "Turks & Caicos Islands",
        "iso": "tc",
        "placeholder": "649 231 1234",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+688",
        "name": "Tuvalu",
        "iso": "tv",
        "placeholder": "90 12345",
        "regex": "^\\d{2} \\d{5}$"
    },
    {
        "code": "+256",
        "name": "Uganda",
        "iso": "ug",
        "placeholder": "0712 345678",
        "regex": "^\\d{4} \\d{6}$"
    },
    {
        "code": "+380",
        "name": "Ukraine",
        "iso": "ua",
        "placeholder": "039 123 4567",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+971",
        "name": "United Arab Emirates",
        "iso": "ae",
        "placeholder": "050 123 4567",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+44",
        "name": "United Kingdom",
        "iso": "gb",
        "placeholder": "7123 456789",
        "regex": "^\\d{4} \\d{6}$"
    },
    {
        "code": "+1",
        "name": "United States",
        "iso": "us",
        "placeholder": "201 555 0123",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+598",
        "name": "Uruguay",
        "iso": "uy",
        "placeholder": "099 123 456",
        "regex": "^\\d{3} \\d{3} \\d{3}$"
    },
    {
        "code": "+1",
        "name": "US Virgin Islands",
        "iso": "vi",
        "placeholder": "340 642 1234",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+998",
        "name": "Uzbekistan",
        "iso": "uz",
        "placeholder": "8 91 234 56 78",
        "regex": "^\\d \\d{2} \\d{3} \\d{2} \\d{2}$"
    },
    {
        "code": "+678",
        "name": "Vanuatu",
        "iso": "vu",
        "placeholder": "591 2345",
        "regex": "^\\d{3} \\d{4}$"
    },
    {
        "code": "+39",
        "name": "Vatican City",
        "iso": "va",
        "placeholder": "06 698 12345",
        "regex": "^\\d{2} \\d{3} \\d{5}$"
    },
    {
        "code": "+58",
        "name": "Venezuela",
        "iso": "ve",
        "placeholder": "0412 1234567",
        "regex": "^\\d{4} \\d{7}$"
    },
    {
        "code": "+84",
        "name": "Vietnam",
        "iso": "vn",
        "placeholder": "091 234 56 78",
        "regex": "^\\d{3} \\d{3} \\d{2} \\d{2}$"
    },
    {
        "code": "+681",
        "name": "Wallis & Futuna",
        "iso": "wf",
        "placeholder": "50 12 34",
        "regex": "^\\d{2} \\d{2} \\d{2}$"
    },
    {
        "code": "+212",
        "name": "Western Sahara",
        "iso": "eh",
        "placeholder": "028 123 4567",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+967",
        "name": "Yemen",
        "iso": "ye",
        "placeholder": "0712 345 678",
        "regex": "^\\d{4} \\d{3} \\d{3}$"
    },
    {
        "code": "+260",
        "name": "Zambia",
        "iso": "zm",
        "placeholder": "095 512 3456",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+263",
        "name": "Zimbabwe",
        "iso": "zw",
        "placeholder": "071 123 4567",
        "regex": "^\\d{3} \\d{3} \\d{4}$"
    },
    {
        "code": "+358",
        "name": "Åland Islands",
        "iso": "ax",
        "placeholder": "041 2345678",
        "regex": "^\\d{3} \\d{7}$"
    }
];
